module.exports = __webpack_public_path__ + "nextcurrent.730d0284.png";